import type { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledLi = styled.li<{ $staticPage?: boolean }>`
  word-break: break-word;
  margin-bottom: 0.5rem;
  font-size: var(--body-font-size);
  line-height: var(--body-line-height);

  @media screen and (min-width: 48rem) {
    padding-left: 0.6rem;
  }

  a {
    font-size: inherit;
    line-height: inherit;
  }

  p {
    margin: 0;
  }

  ${({ $staticPage }) =>
    $staticPage &&
    css`
      line-height: 1.375;

      @media screen and (min-width: 48rem) {
        line-height: 1.4;
      }

      a {
        line-height: inherit;
      }
    `}
`

const ListItem: FunctionComponent<{
  children: ReactNode
  staticPage?: boolean
}> = ({ children, staticPage }) => {
  return <StyledLi $staticPage={staticPage}>{children}</StyledLi>
}

export default ListItem
